const endpoints = {
  auth: {
    login: "/auth/login",
    signup: "/auth/register",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    verifyEmail: "/auth/verify-otp",
    resendOtp: "/auth/resend-otp",
    googleLogin: "/auth/google-login",
    logout: "/auth/logout",
  },

  user: {
    getProfile: "/profile/me",
    updateProfile: "/profile/me/profile-detail",
    updateProfileImage: "/profile/me/profile-image",
    changePassword: "/profile/me/change-password",
    headerProfile: "/profile/me/header",
    connectedApps: "/profile/me/connected-apps",
    stravaAuthUrl: "/profile/me/strava/auth-url",
    disconnectStrava: "/profile/me/strava/disconnect",
    activityHistory: "/profile/activity-history",
    distancePreference: "/profile/me/distance-preference",
  },
  challengeOrders: {
  challengeStatus: (challengeId) =>
    `/challenge-orders/challenge-status/${challengeId}`,
   myChallengeDetails: (id) =>
    `/challenge-orders/my-challenge/${id}`,
   applyCoupon: "/challenge-orders",
   },

  dashboard: {
    overview: "/dashboard/dashboard-overview",
  },
  profile: {
    myChallenges: "/profile/my-challenges",
     missionDetails: (id) =>
    `/challenge-orders/mission-details/${id}`,

    pauseCurrent: "/profile/pause-current",
    startChallenge: (challengeId) => `/challenge-orders/start/${challengeId}`,
  },

  rewards: {
    
    challengeList:
      "/challenge-postcard/challenges-list",

   
    postcardList: (challengeId) =>
      `/challenge-postcard/postcard-list/${challengeId}`,

   
    downloadCertificate: (challengeId) =>
      `/challenge-postcard/completion-certificate/${challengeId}`,
  },
  challenges: {
    missionManagementChallenges: "/admin/mission-management-challenges",
    challengeDetails: (id) => `/admin/challenges-Details/${id}`,
    favouriteChallenge: "/user-fav-challenge",
    getFavouriteStatus: (id) => `/user-fav-challenge/favourite/${id}`,
    myInitiatedChallenges:"/challenge-orders/my-initiated-challenges",
  },

  cms: {
    dashboardCms: "/dashboard/cms",
    termsConditions: "/cms/terms-and-conditions",
    privacyPolicy: "/cms/privacy-policy",
    faq: "/cms/faq",
    aboutUs: "/cms/about-us",
  },

  teammanagment: {
    teamlist: "/challenge-team/my-teams",
    createdTeams: "/challenge-team/teams",
    teamdetail: (id) => `/challenge-team/team-details/${id}`,
    createteam: "/challenge-team/create-team",
    challengeslist: "/challenge-team/all-my-challenges",
    editgroup: (id) => `/challenge-team/update-team/${id}`,
     challengeTeams: (id) =>
    `/challenge-team/challenge/${id}/teams`,
     sendInvite: "/invite-member/send",
     joinRequest: "/challenge-team/join-request",
  },

  payment_order: {
    orderlist: "/admin/my-orders",
    createOrder: "/challenge-orders",
  },

  payment: {
    createCheckout: (orderId) => `/stripe/checkout/${orderId}`,
  },
  
marketingCampaign: {
    getCampaigns: "/marketing-campaign",
  },
  
  notifications: {
    saveToken: "/notifications/save-token",
    latest: "/notifications/latest",
    viewAll: "/notifications/view-all",
    markAllRead: "/notifications/mark-all-read",
    markSingleRead: (id) => `/notifications/read/${id}`,
  },
  
  community: {
  record: "/community/record",
},

  distance: {
  addDistance: "/challenge-orders/add-distance",
  distanceCovered: (id) => `/challenge-orders/${id}/distance-covered`, 
},
};

export default endpoints;
